<template>
    <div class="main text-center">
        <v-card class="ma-3">
            <v-card-title class="headline">Přihlášení</v-card-title>
            <v-card-text>
                <v-form ref="form" v-model="valid" @keyup.enter="validate">
                    <p
                        class="mb-10 text-left"
                        style="color: darkred; border: 1px solid darkred; padding: 10px;"
                    >
                        Máme sjednocené přihlášení na Inspector s administrací
                        e-shopu, přihlašujte se prosím nově e-mailem a heslem,
                        který používáte pro přihlášení do administrace e-shopu.
                        V případě potíží s přihlášením nás prosím kontaktujte na
                        stránce podpory.
                    </p>
                    <v-text-field
                        v-model="username"
                        :rules="usernameRules"
                        label="E-mail uživatele"
                        ref="username"
                        required
                        :disabled="loginRunning"
                    ></v-text-field>

                    <v-text-field
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPassword ? 'text' : 'password'"
                        v-model="password"
                        :rules="passwordRules"
                        label="Heslo"
                        @keyup.enter="validate"
                        required
                        class="mt-5"
                        :disabled="loginRunning"
                        @click:append="showPassword = !showPassword"
                    ></v-text-field>
                </v-form>

                <v-alert v-if="loginError" type="error">
                    Chyba přihlašování, zkontrolujte přihlašovací údaje
                </v-alert>
            </v-card-text>
            <v-card-actions>
                <v-btn :disabled="!valid || loginRunning" color="success" @click="validate">
                    Přihlásit

                    <v-progress-circular v-if="loginRunning" indeterminate size="24" class="ml-3"></v-progress-circular>
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
export default {
    data: () => ({
        valid: true,
        username: "",
        usernameRules: [
            v => v.length > 3 || "Vyplňte e-mail uživatele",
            v =>
                v.includes("@") ||
                "Použijte e-mail uživatele stejně jako při přihlášení do administace e-shopu"
        ],
        password: "",
        passwordRules: [v => !!v || "Vyplňte heslo"],
        showPassword: false,
        loginError: false,
        loginRunning: false
    }),

    mounted() {
        this.$refs["username"].focus();
    },

    methods: {
        async validate() {
            this.loginError = false;

            if (this.$refs.form.validate()) {
                this.loginRunning = true;

                const result = await this.$store.dispatch("user/login", {
                    username: this.username,
                    password: this.password
                });
                if (result.ok) {
                    this.$router.push({ name: "events" });
                } else {
                    this.loginError = true;
                }

                this.loginRunning = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.main {
    width: 100%;
    max-width: 500px;
}
</style>
